import React from "react";

import { getTextColor } from "@intelligems/ig-utils";

import { ProgressBarWidgetIconProps } from "../../../../types/widgets";

export const ProgressBarWidget2 = (props: ProgressBarWidgetIconProps) => (
  <svg
    width="306"
    height="27"
    viewBox="0 0 306 27"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <line
      x1="15"
      y1="15"
      x2="300"
      y2="15"
      stroke={props.inactivebarcolor || "#E0E0E0"}
      strokeWidth="12"
      strokeLinecap="round"
    />
    <path
      d={`M6 15L${(props.barprogress && props.barprogress) || 30} 15`}
      stroke={props.activebarcolor || "#909090"}
      strokeWidth="12"
      strokeLinecap="round"
    />
    <circle
      cx="39"
      cy="13.5"
      r="13"
      fill={
        typeof props.threshold === "number" &&
        props.threshold >= 0 &&
        props.discountstate &&
        props.threshold < props.discountstate.tiers[0].minimumUnits
          ? props.breakpointinactive || "#E0E0E0"
          : props.breakpointactive || "#909090"
      }
    />
    <path
      d={
        typeof props.threshold === "number" &&
        props.threshold >= 0 &&
        props.discountstate &&
        props.threshold < props.discountstate.tiers[0].minimumUnits
          ? "M33.1719 20.3462C32.8477 20.3462 32.5703 20.2333 32.3437 20.0037C32.1172 19.774 32 19.5016 32 19.1786V10.7331C32 10.41 32.1133 10.1337 32.3437 9.90797C32.5742 9.68224 32.8477 9.56548 33.1719 9.56548H34.5391V7.69734C34.5391 6.67376 34.9023 5.79808 35.6211 5.08196C36.3437 4.36195 37.2187 4 38.25 4C39.2813 4 40.1562 4.35806 40.8789 5.08196C41.6016 5.80197 41.9609 6.67376 41.9609 7.69734V9.56548H43.3281C43.6523 9.56548 43.9297 9.67834 44.1563 9.90797C44.3828 10.1376 44.5 10.41 44.5 10.7331V19.1786C44.5 19.5016 44.3867 19.7779 44.1563 20.0037C43.9258 20.2294 43.6523 20.3462 43.3281 20.3462H33.1719ZM35.7109 9.56548H40.7891V7.69734C40.7891 6.9968 40.543 6.40133 40.0469 5.90705C39.5508 5.41277 38.9531 5.16758 38.25 5.16758C37.5469 5.16758 36.9492 5.41277 36.4531 5.90705C35.957 6.40133 35.7109 6.9968 35.7109 7.69734V9.56548ZM33.1719 19.1786H43.3281V10.7331H33.1719V19.1786ZM38.25 16.4542C38.668 16.4542 39.0234 16.3102 39.3164 16.0261C39.6094 15.742 39.7539 15.3956 39.7539 14.9947C39.7539 14.5939 39.6055 14.2514 39.3164 13.9322C39.0234 13.6131 38.668 13.4535 38.25 13.4535C37.832 13.4535 37.4766 13.6131 37.1836 13.9322C36.8906 14.2514 36.7461 14.6055 36.7461 14.9947C36.7461 15.3839 36.8945 15.742 37.1836 16.0261C37.4727 16.3102 37.832 16.4542 38.25 16.4542Z"
          : "M36.7508 16.1502L33.6008 13.0002L32.5508 14.0502L36.7508 18.2502L45.7508 9.2502L44.7008 8.2002L36.7508 16.1502Z"
      }
      fill={
        typeof props.threshold === "number" &&
        props.threshold >= 0 &&
        props.discountstate &&
        props.threshold < props.discountstate.tiers[0].minimumUnits
          ? getTextColor(props.breakpointinactive || "#5A5A5A")
          : getTextColor(props.breakpointactive || "#494C50")
      }
    />
    <circle
      cx="119.5"
      cy="13.5"
      r="13"
      fill={
        (typeof props.threshold === "number" &&
          props.threshold >= 0 &&
          props.discountstate &&
          props.threshold < props.discountstate.tiers[1].minimumUnits) ||
        props.ispreview
          ? props.breakpointinactive || "#E0E0E0"
          : props.breakpointactive || "#E0E0E0"
      }
    />
    <path
      d={
        (typeof props.threshold === "number" &&
          props.threshold >= 0 &&
          props.discountstate &&
          props.threshold < props.discountstate.tiers[1].minimumUnits) ||
        props.ispreview
          ? "M114.172 20.3462C113.848 20.3462 113.57 20.2333 113.344 20.0037C113.117 19.774 113 19.5016 113 19.1786V10.7331C113 10.41 113.113 10.1337 113.344 9.90797C113.574 9.68224 113.848 9.56548 114.172 9.56548H115.539V7.69734C115.539 6.67376 115.902 5.79808 116.621 5.08196C117.344 4.36195 118.219 4 119.25 4C120.281 4 121.156 4.35806 121.879 5.08196C122.602 5.80197 122.961 6.67376 122.961 7.69734V9.56548H124.328C124.652 9.56548 124.93 9.67834 125.156 9.90797C125.383 10.1376 125.5 10.41 125.5 10.7331V19.1786C125.5 19.5016 125.387 19.7779 125.156 20.0037C124.926 20.2294 124.652 20.3462 124.328 20.3462H114.172ZM116.711 9.56548H121.789V7.69734C121.789 6.9968 121.543 6.40133 121.047 5.90705C120.551 5.41277 119.953 5.16758 119.25 5.16758C118.547 5.16758 117.949 5.41277 117.453 5.90705C116.957 6.40133 116.711 6.9968 116.711 7.69734V9.56548ZM114.172 19.1786H124.328V10.7331H114.172V19.1786ZM119.25 16.4542C119.668 16.4542 120.023 16.3102 120.316 16.0261C120.609 15.742 120.754 15.3956 120.754 14.9947C120.754 14.5939 120.605 14.2514 120.316 13.9322C120.023 13.6131 119.668 13.4535 119.25 13.4535C118.832 13.4535 118.477 13.6131 118.184 13.9322C117.891 14.2514 117.746 14.6055 117.746 14.9947C117.746 15.3839 117.895 15.742 118.184 16.0261C118.473 16.3102 118.832 16.4542 119.25 16.4542Z"
          : "M117.751 16.1502L114.601 13.0002L113.551 14.0502L117.751 18.2502L126.751 9.2502L125.701 8.2002L117.751 16.1502Z"
      }
      fill={
        (typeof props.threshold === "number" &&
          props.threshold >= 0 &&
          props.discountstate &&
          props.threshold < props.discountstate.tiers[1].minimumUnits) ||
        props.ispreview
          ? getTextColor(props.breakpointinactive || "#5A5A5A")
          : getTextColor(props.breakpointactive || "#494C50")
      }
    />
    <circle
      cx="204.5"
      cy="13.5"
      r="13"
      fill={
        (typeof props.threshold === "number" &&
          props.threshold >= 0 &&
          props.discountstate &&
          props.threshold < props.discountstate.tiers[2].minimumUnits) ||
        props.ispreview
          ? props.breakpointinactive || "#E0E0E0"
          : props.breakpointactive || "#E0E0E0"
      }
      stroke={"#E0E0E0"}
    />
    <path
      d={
        (typeof props.threshold === "number" &&
          props.threshold >= 0 &&
          props.discountstate &&
          props.threshold < props.discountstate.tiers[2].minimumUnits) ||
        props.ispreview
          ? "M199.172 20.3462C198.848 20.3462 198.57 20.2333 198.344 20.0037C198.117 19.774 198 19.5016 198 19.1786V10.7331C198 10.41 198.113 10.1337 198.344 9.90797C198.574 9.68224 198.848 9.56548 199.172 9.56548H200.539V7.69734C200.539 6.67376 200.902 5.79808 201.621 5.08196C202.344 4.36195 203.219 4 204.25 4C205.281 4 206.156 4.35806 206.879 5.08196C207.602 5.80197 207.961 6.67376 207.961 7.69734V9.56548H209.328C209.652 9.56548 209.93 9.67834 210.156 9.90797C210.383 10.1376 210.5 10.41 210.5 10.7331V19.1786C210.5 19.5016 210.387 19.7779 210.156 20.0037C209.926 20.2294 209.652 20.3462 209.328 20.3462H199.172ZM201.711 9.56548H206.789V7.69734C206.789 6.9968 206.543 6.40133 206.047 5.90705C205.551 5.41277 204.953 5.16758 204.25 5.16758C203.547 5.16758 202.949 5.41277 202.453 5.90705C201.957 6.40133 201.711 6.9968 201.711 7.69734V9.56548ZM199.172 19.1786H209.328V10.7331H199.172V19.1786ZM204.25 16.4542C204.668 16.4542 205.023 16.3102 205.316 16.0261C205.609 15.742 205.754 15.3956 205.754 14.9947C205.754 14.5939 205.605 14.2514 205.316 13.9322C205.023 13.6131 204.668 13.4535 204.25 13.4535C203.832 13.4535 203.477 13.6131 203.184 13.9322C202.891 14.2514 202.746 14.6055 202.746 14.9947C202.746 15.3839 202.895 15.742 203.184 16.0261C203.473 16.3102 203.832 16.4542 204.25 16.4542Z"
          : "M203.751 16.1502L200.601 13.0002L199.551 14.0502L203.751 18.2502L212.751 9.2502L211.701 8.2002L203.751 16.1502Z"
      }
      fill={
        (typeof props.threshold === "number" &&
          props.threshold >= 0 &&
          props.discountstate &&
          props.threshold < props.discountstate.tiers[2].minimumUnits) ||
        props.ispreview
          ? getTextColor(props.breakpointinactive || "#5A5A5A")
          : getTextColor(props.breakpointactive || "#494C50")
      }
    />
    <circle
      cx="277.5"
      cy="13.5"
      r="13"
      fill={
        (typeof props.threshold === "number" &&
          props.threshold >= 0 &&
          props.discountstate &&
          props.threshold < props.discountstate.tiers[3].minimumUnits) ||
        props.ispreview
          ? props.breakpointinactive || "#E0E0E0"
          : props.breakpointactive || "#E0E0E0"
      }
      stroke="#E0E0E0"
    />
    <path
      d={
        (typeof props.threshold === "number" &&
          props.threshold >= 0 &&
          props.discountstate &&
          props.threshold < props.discountstate.tiers[3].minimumUnits) ||
        props.ispreview
          ? "M272.172 20.3462C271.848 20.3462 271.57 20.2333 271.344 20.0037C271.117 19.774 271 19.5016 271 19.1786V10.7331C271 10.41 271.113 10.1337 271.344 9.90797C271.574 9.68224 271.848 9.56548 272.172 9.56548H273.539V7.69734C273.539 6.67376 273.902 5.79808 274.621 5.08196C275.344 4.36195 276.219 4 277.25 4C278.281 4 279.156 4.35806 279.879 5.08196C280.602 5.80197 280.961 6.67376 280.961 7.69734V9.56548H282.328C282.652 9.56548 282.93 9.67834 283.156 9.90797C283.383 10.1376 283.5 10.41 283.5 10.7331V19.1786C283.5 19.5016 283.387 19.7779 283.156 20.0037C282.926 20.2294 282.652 20.3462 282.328 20.3462H272.172ZM274.711 9.56548H279.789V7.69734C279.789 6.9968 279.543 6.40133 279.047 5.90705C278.551 5.41277 277.953 5.16758 277.25 5.16758C276.547 5.16758 275.949 5.41277 275.453 5.90705C274.957 6.40133 274.711 6.9968 274.711 7.69734V9.56548ZM272.172 19.1786H282.328V10.7331H272.172V19.1786ZM277.25 16.4542C277.668 16.4542 278.023 16.3102 278.316 16.0261C278.609 15.742 278.754 15.3956 278.754 14.9947C278.754 14.5939 278.605 14.2514 278.316 13.9322C278.023 13.6131 277.668 13.4535 277.25 13.4535C276.832 13.4535 276.477 13.6131 276.184 13.9322C275.891 14.2514 275.746 14.6055 275.746 14.9947C275.746 15.3839 275.895 15.742 276.184 16.0261C276.473 16.3102 276.832 16.4542 277.25 16.4542Z"
          : "M275.751 16.1502L272.601 13.0002L271.551 14.0502L275.751 18.2502L284.751 9.2502L283.701 8.2002L275.751 16.1502Z"
      }
      fill={
        (typeof props.threshold === "number" &&
          props.threshold >= 0 &&
          props.discountstate &&
          props.threshold < props.discountstate.tiers[3].minimumUnits) ||
        props.ispreview
          ? getTextColor(props.breakpointinactive || "#5A5A5A")
          : getTextColor(props.breakpointactive || "#494C50")
      }
    />
  </svg>
);
